    <div class="c-container">
        <p-tabMenu [model]="items" [activeItem]="activeItem" [ngStyle]="{ 'width': '100%' }"></p-tabMenu>

        <div *ngIf="activeTab === 'data'" >
            <div class="overlay" *ngIf="isLoadingAccount">
            <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
            </div>

            <!-- Foto de perfil -->
            <div class="account-avatar" *ngIf="!isLoadingAccount">
              <div class="account-avatar__wrap" (click)="avatarInput.click()"
                   [class.account-avatar__wrap--loading]="avatarUploading">
                <img *ngIf="avatarUrl" [src]="avatarUrl" class="account-avatar__img" alt="Avatar" />
                <span *ngIf="!avatarUrl && avatarInitials" class="account-avatar__initials">{{ avatarInitials }}</span>
                <i *ngIf="!avatarUrl && !avatarInitials" class="pi pi-user account-avatar__placeholder"></i>
                <div class="account-avatar__overlay">
                  <i class="pi" [ngClass]="avatarUploading ? 'pi-spin pi-spinner' : 'pi-camera'"></i>
                </div>
              </div>
              <input #avatarInput type="file"
                     accept=".jpg,.jpeg,.png,.webp,.gif,.avif,image/jpeg,image/png,image/webp,image/gif,image/avif"
                     (change)="onAvatarSelected($event)" hidden />
              <button type="button" class="account-avatar__btn" [disabled]="avatarUploading" (click)="avatarInput.click()">
                <i class="pi pi-camera"></i>
                {{ (avatarUploading ? 'socialFeed.saving' : 'socialFeed.changePhoto') | transloco }}
              </button>
            </div>

            <!-- Ajuste de recorte (1:1, circular) antes de subir a nova foto. -->
            <app-avatar-cropper [(visible)]="avatarCropperVisible" [file]="avatarFileToCrop"
                                (cropped)="onAvatarCropped($event)"></app-avatar-cropper>

            <div class="form-storage-wrapper">

            <!-- FORMULÁRIOS -->
            <div class="form-section">
                <form class="c-form skel-container" *ngIf="isLoadingAccount">
                <p-skeleton height="48px" styleClass="skel" />
                <p-skeleton height="48px" styleClass="skel" />
                <p-skeleton height="48px" styleClass="skel" />
                <p-skeleton height="48px" styleClass="skel" />
                <p-skeleton height="48px" styleClass="skel" />
                <p-skeleton height="48px" styleClass="skel" />
                <div class="flex align-items-end">
                    <p-skeleton shape="circle" size="4rem" styleClass="skel circle" />
                    <p-skeleton shape="circle" size="4rem" styleClass="skel circle" />
                    <p-skeleton shape="circle" size="4rem" styleClass="skel circle" />
                </div>
                </form>

                <form class="c-form" [formGroup]="form" *ngIf="!isLoadingAccount" (ngSubmit)="onSubmit()">
                <div class="field">
                    <label class="field__label" for="country">{{ 'user.account.countryLabel' | transloco }}</label>
                    <p-dropdown id="country" [options]="countryOptions" formControlName="country" name="country"
                        (onChange)="setIsBrasil()" optionLabel="name" [placeholder]="'user.account.country' | transloco"
                        [emptyMessage]="'noResult' | transloco" [filter]="true" [filterBy]="'name'">
                    </p-dropdown>
                </div>

                <div class="field">
                    <label class="field__label" for="name">{{ 'user.account.fullName' | transloco }}</label>
                    <input id="name" class="name" formControlName="name" name="name" type="text"
                        maxlength="100" [placeholder]="placeHolderName" pInputText />
                    <small *ngIf="f.name.dirty && f.name.hasError('pattern')" class="field-error">
                      <i class="pi pi-exclamation-circle"></i> {{ 'user.createAccount.nameInvalidChars' | transloco }}
                    </small>
                </div>

                <div class="field" *ngIf="isBrasil">
                    <label class="field__label" for="docNumber">{{ 'user.account.cpfLabel' | transloco }}</label>
                    <input id="docNumber" formControlName="docNumber" name="docNumber" [placeholder]="'common.placeholders.cpfCnpj' | transloco"
                        (blur)="getMaskDocNumber()" maxlength="18" [style]="{ 'width': '100%' }" pInputText />
                </div>

                <div class="field" *ngIf="showBirthDate">
                    <label class="field__label" for="birthDate">{{ 'user.account.birthDate' | transloco }}</label>
                    <p-calendar *ngIf="isBrasilDate" id="birthDate"
                        placeholder="{{ 'user.account.birthDate' | transloco }}*" formControlName="birthDate" name="birthDate"
                        [minDate]="minDate" [maxDate]="maxDate" dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false" />
                    <p-calendar *ngIf="!isBrasilDate" id="birthDate"
                        placeholder="{{ 'user.account.birthDate' | transloco }}*" formControlName="birthDate" name="birthDate"
                        [minDate]="minDate" [maxDate]="maxDate" dateFormat="mm/dd/yy" [showIcon]="true" [showOnFocus]="false" />
                </div>

                <div class="phone-container">
                    <div class="country-selector field">
                    <label class="field__label">{{ 'user.account.phoneCountryCode' | transloco }}</label>
                    <p-dropdown [options]="countries" formControlName="phoneCountry" optionLabel="name" [placeholder]="'common.placeholders.country' | transloco"
                        (onChange)="updateMask()" [filter]="true" [filterBy]="'name,dialCode'"
                        scrollHeight="240px">
                        <ng-template let-country pTemplate="item">
                        <div class="country-option">
                            <img [src]="country.flag" alt="{{ country.name }}" class="flag" />
                            {{ country.name }} ({{ country.dialCode }})
                        </div>
                        </ng-template>
                        <ng-template let-country pTemplate="selectedItem">
                        <div class="selected-country">
                            <img [src]="country.flag" alt="{{ country.name }}" class="flag" />
                            {{ country.dialCode }}
                        </div>
                        </ng-template>
                    </p-dropdown>
                    </div>
                    <div class="field phone-field">
                    <label class="field__label" for="phone">{{ 'user.account.phone' | transloco }}</label>
                    <p-inputMask id="phone" formControlName="phone" name="phone" [mask]="currentMask" unmask="true"
                    [style]="{ 'width': '100%' }" placeholder="{{ 'user.account.phone' | transloco }}*" />
                    </div>
                </div>

                <div class="field">
                    <label class="field__label" for="email">{{ 'user.account.email' | transloco }}</label>
                    <input class="email" type="email" id="email" name="email" formControlName="email"
                        placeholder="{{ 'user.account.email' | transloco }}" pInputText />
                </div>

                <p-selectButton id="language" name="language" formControlName="language" [options]="languageOptions"
                    optionLabel="name" (onChange)="onLanguageSelected()">
                    <ng-template let-item pTemplate>
                    <div [class]="item.class"></div>
                    </ng-template>
                </p-selectButton>

                <div class="c-row">
                    <p-inputSwitch id="checkNewsletter" formControlName="checkNewsletter" />
                    <label id="labelCheckNewsletter" for="checkNewsletter">
                    {{ 'user.account.checkNewsletter' | transloco }}
                    </label>
                </div>

                <div class="c-row">
                    <p-inputSwitch id="mfaEnabled" [(ngModel)]="mfaEnabled" [ngModelOptions]="{ standalone: true }">
                    </p-inputSwitch>
                    <label id="labelMfaEnabled" for="mfaEnabled">
                    {{ 'user.account.mfaEnabled' | transloco }}
                    </label>
                </div>

               

                <p-dropdown *ngIf="f.inactive.value" id="inactiveReason" [options]="inactiveReasonOptions"
                    formControlName="inactiveReason" name="inactiveReason" optionLabel="description"
                    placeholder="{{ 'user.account.inactiveReason' | transloco }}"
                    emptyMessage="{{ 'noResult' | transloco }}" />

                <p-toast key="toastAccount" />

                <div class="btns">
                    <!-- <p-button id="btnChangePassword" severity="secondary" [raised]="true"
                    label="{{'user.account.changePassword.buttonChangePassword' | transloco }}"
                    (click)="openChangePasswordModal()">
                    </p-button> -->
                    <div class="button-wrapper" (click)="openChangePasswordModal()">
                        <div class="button-inner">
                            <p-button id="btnChangePassword" name="btnChangePassword" label="{{'user.account.changePassword.buttonChangePassword' | transloco }}" [raised]="true"
                                styleClass="custom-button"></p-button>
                        </div>
                    </div>
                    <div class="button-wrapper" (click)="backPage()">
                        <div class="button-inner">
                            <p-button id="btnBackLogin" name="btnBackLogin"
                                label="{{'user.account.btnBack' | transloco }}" [loading]="backBtnLoading" [raised]="true"
                                styleClass="custom-button"></p-button>
                        </div>
                    </div>

                    <!-- <p-button id="btnBackLogin" severity="secondary" [raised]="true" [loading]="backBtnLoading"
                    (click)="backPage()" label="{{'user.account.btnBack' | transloco }}">
                    </p-button> -->

                    <p-button type="submit" severity="danger" [raised]="true" [loading]="submitBtnLoading"
                    label="{{'user.account.btnSave' | transloco }}">
                    </p-button>
                </div>

                <div class="c-row footerMsg" style="padding-bottom: 50px;">
                    {{'user.account.footerMsg' | transloco}}
                </div>

                <div class="c-row export-section">
                    <h3 class="export-section__title">{{ 'user.dataExport.accountTitle' | transloco }}</h3>
                    <app-data-export></app-data-export>
                </div>

                 <div class="c-row">
                    <div class="button-wrapper button-wrapper--quiet" (click)="goToAccountDeletion()">
                        <div class="button-inner">
                            <p-button id="btnInactive" name="btnInactive"
                                label="{{'user.accountDeletion.openPage' | transloco}}" [raised]="true"
                                styleClass="custom-button"></p-button>
                        </div>
                    </div>
                </div>

                </form>

                <form class="c-form" [formGroup]="changePasswordForm" (ngSubmit)="submitChangePassword()">
                <p-dialog id="modal-changePassword" name="modal-changePassword" [modal]="true"
                    header="{{'user.account.changePassword.modal.title' | transloco}}" [draggable]="false"
                    [(visible)]="showChagePasswordModal" (onHide)="closeChangePasswordModal()"
                    [style]="{ 'max-width': '90%', 'width': '630px', 'border-radius': '10px' }"
                    [contentStyle]="{ 'overflow': 'visible' }">
                    <div class="p-dialog-content">
                    <p-password class="ig-pass" id="oldPassword" name="password" formControlName="oldPassword"
                        placeholder="{{ 'user.account.changePassword.modal.inputOldPassword' | transloco }}" [feedback]="false"
                        [toggleMask]="true" [style]="{ 'width': '100%' }" [inputStyle]="{ 'width': '100%' }" />
                    <p-password class="ig-pass" id="newPassword" name="newPassword" formControlName="newPassword"
                        placeholder="{{ 'user.account.changePassword.modal.inputNewPassword' | transloco }}" [feedback]="false"
                        [toggleMask]="true" [style]="{ 'width': '100%', 'margin-top': '15px' }"
                        [inputStyle]="{ 'width': '100%' }" />
                    <app-password-strength-checklist
                      [password]="changePasswordForm.get('newPassword')?.value">
                    </app-password-strength-checklist>
                    <small id="password-help">
                        {{ 'user.createAccount.passwordText' | transloco }}
                    </small>
                    <p-messages id="messages" [(value)]="messagesPassword" [enableService]="false"
                        [style]="{ 'font-size': '15px', 'margin-top': '10px' }" />
                    </div>
                    <div class="p-dialog-footer" style="padding: 0;">
                    <button class="p-button" style="border-color: transparent;" pButton
                        label="{{'user.account.changePassword.modal.cancelButton' | transloco}}" [outlined]="true"
                        (click)="closeChangePasswordModal()"></button>
                    <p-button type="submit" severity="danger" [raised]="true"
                        label="{{'user.account.changePassword.modal.confirmButton' | transloco}}">
                    </p-button>
                    </div>
                </p-dialog>
                </form>
            </div>

            <!-- STORAGE À DIREITA -->
            <div class="storage-container">
                <div class="storage-header">
                    <h2>{{ 'admin.accordionTab.storage.storageUsing' | transloco }}</h2>
                    <span class="storage-summary-badge">
                        {{ usedStorage | storageFormat }} / {{ totalStorage | storageFormat }}
                    </span>
                </div>

                <!-- Barra empilhada total -->
                <div class="storage-bar-total">
                    <div *ngFor="let item of storageData"
                         class="storage-bar-segment"
                         [ngStyle]="{
                             'width.%': totalStorage > 0 ? (item.value / totalStorage) * 100 : 0,
                             'background-color': item.color
                         }"
                         [title]="(item.label | transloco) + ': ' + (item.value | storageFormat)">
                    </div>
                    <div class="storage-bar-free"
                         [ngStyle]="{ 'flex': '1' }"
                         [title]="'common.labels.available' | transloco">
                    </div>
                </div>

                <!-- Legenda do total -->
                <div class="storage-bar-legend">
                    <span class="storage-used-pct" [style.color]="usedStorage / totalStorage > 0.8 ? '#e74c3c' : null">
                        {{ (usedStorage / totalStorage * 100) | number:'1.0-0' }}% {{ 'common.labels.used' | transloco }}
                    </span>
                    <span class="storage-free-pct">
                        {{ ((totalStorage - usedStorage) / totalStorage * 100) | number:'1.0-0' }}% {{ 'common.labels.free' | transloco }}
                    </span>
                </div>

                <!-- Linhas individuais por categoria -->
                <div class="storage-categories">
                    <div *ngFor="let item of storageData" class="storage-category-row">
                        <div class="storage-cat-left">
                            <i class="pi {{ item.icon }} storage-cat-icon" [ngStyle]="{ 'color': item.color }"></i>
                            <span class="storage-cat-label">{{ item.label | transloco }}</span>
                        </div>
                        <div class="storage-cat-bar-wrap">
                            <div class="storage-cat-bar-bg">
                                <div class="storage-cat-bar-fill"
                                     [ngStyle]="{
                                         'width.%': totalStorage > 0 ? (item.value / totalStorage) * 100 : 0,
                                         'background-color': item.color
                                     }">
                                </div>
                            </div>
                        </div>
                        <span class="storage-cat-value">{{ item.value | storageFormat }}</span>
                    </div>
                </div>

                <!-- Bloco Tuner -->
                <div class="tuner-section" *ngIf="accountType !== 'tuner'">
                    <!-- Plano Pro/Ultra: pode se tornar tuner -->
                    <div class="tuner-invite-block" *ngIf="!tunerGateLoading && canBeTuner">
                        <div class="tuner-invite-icon"><i class="pi pi-users"></i></div>
                        <div class="tuner-invite-text">
                            <strong>{{ 'tuner.becomeTuner.title' | transloco }}</strong>
                            <span>{{ 'tuner.becomeTuner.desc' | transloco }}</span>
                        </div>
                        <button class="sub-upgrade-btn tuner-become-btn"
                                [disabled]="becomeTunerLoading"
                                (click)="becomeTuner()">
                            <i class="pi pi-star"></i>
                            {{ becomeTunerLoading ? ('tuner.becomeTuner.loading' | transloco) : ('tuner.becomeTuner.btn' | transloco) }}
                        </button>
                    </div>

                    <!-- Plano abaixo de Pro: recurso bloqueado, CTA de upgrade em vez de botão que tomaria 403 -->
                    <div class="tuner-invite-block" *ngIf="!tunerGateLoading && !canBeTuner">
                        <div class="tuner-invite-icon tuner-icon-locked"><i class="pi pi-lock"></i></div>
                        <div class="tuner-invite-text">
                            <strong>{{ 'tuner.becomeTuner.lockedTitle' | transloco }}</strong>
                            <span>{{ 'tuner.becomeTuner.lockedDesc' | transloco }}</span>
                        </div>
                        <button class="sub-upgrade-btn tuner-become-btn" (click)="showUpgradeModal = true">
                            <i class="pi pi-arrow-up"></i>
                            {{ 'tuner.becomeTuner.lockedBtn' | transloco }}
                        </button>
                    </div>
                </div>

                <div class="tuner-section" *ngIf="accountType === 'tuner'">
                    <div class="tuner-invite-block">
                        <div class="tuner-invite-icon tuner-icon-active"><i class="pi pi-star-fill"></i></div>
                        <div class="tuner-invite-text">
                            <strong>{{ 'tuner.becomeTuner.alreadyTunerTitle' | transloco }}</strong>
                            <span>{{ 'tuner.becomeTuner.alreadyTunerDesc' | transloco }}</span>
                        </div>
                        <button class="sub-manage-btn" (click)="goToTunerPanel()">
                            <i class="pi pi-external-link"></i>
                            {{ 'tuner.becomeTuner.panelBtn' | transloco }}
                        </button>
                    </div>
                </div>
            </div>
            </div>

        </div>
    </div>

    <!-- TAB ASSINATURA -->
    <div *ngIf="activeTab === 'subscription'" class="subscription-tab-container">
        <p-toast key="toastAccount" />

        <!-- Plano expirado -->
        <div *ngIf="planInformation?.status === 'expired'" class="sub-empty-state sub-expired-state">
            <i class="pi pi-clock sub-empty-icon sub-empty-icon--expired"></i>
            <h3 class="sub-empty-title">{{ 'user.account.subscriptionTab.expiredTitle' | transloco: { name: planInformation?.name } }}</h3>
            <p class="sub-empty-desc">{{ 'user.account.subscriptionTab.expiredDesc' | transloco }}</p>
            <button class="sub-upgrade-btn" (click)="showUpgradeModal = true">
                <i class="pi pi-refresh"></i> {{ 'user.account.subscriptionTab.renewBtn' | transloco }}
            </button>
        </div>

        <!-- Recibos (plano expirado — quem já foi pagante ainda pode consultar recibos antigos) -->
        <div *ngIf="planInformation?.status === 'expired'" class="sub-invoices-section">
            <app-invoice-list-panel (viewDetails)="openInvoiceDetail($event)"></app-invoice-list-panel>
        </div>

        <!-- Sem plano pago -->
        <div *ngIf="!(planInformation?.status === 'active' || planInformation?.status === 'pending_payment' || planInformation?.status === 'expired')" class="sub-empty-state">
            <i class="pi pi-credit-card sub-empty-icon"></i>
            <h3 class="sub-empty-title">{{ 'user.account.subscriptionTab.emptyTitle' | transloco }}</h3>
            <p class="sub-empty-desc">{{ 'user.account.subscriptionTab.emptyDesc' | transloco }}</p>
            <button class="sub-upgrade-btn" (click)="showUpgradeModal = true">
                <i class="pi pi-arrow-up"></i> {{ 'user.account.subscriptionTab.viewPlansBtn' | transloco }}
            </button>
        </div>

        <!-- Com plano ativo ou pendente -->
        <div *ngIf="planInformation && (planInformation?.status === 'active' || planInformation?.status === 'pending_payment')" class="sub-tuner-row">

            <!-- Assinatura (esquerda) -->
            <div class="sub-active-container">
                <div class="subscription-card">
                    <div class="sub-card-info">
                        <span class="sub-eyebrow">{{ 'user.account.subscriptionTab.currentPlan' | transloco }}</span>
                        <div class="sub-headline">
                            <span class="sub-plan-name">{{ planInformation?.name }}</span>
                            <span class="sub-status-badge"
                                  [ngClass]="'sub-status-' + (planInformation?.status || 'none')">
                                {{ planInformation?.status === 'active'
                                    ? ('user.account.subscriptionTab.statusActive' | transloco)
                                    : planInformation?.status === 'pending_payment'
                                        ? ('user.account.subscriptionTab.statusPendingPayment' | transloco)
                                        : planInformation?.status }}
                            </span>
                        </div>
                        <p class="sub-renewal" *ngIf="planInformation?.remainingDays != null && planInformation?.status === 'active'">
                            {{ 'user.account.subscriptionTab.renewsIn' | transloco: { days: planInformation?.remainingDays } }}
                        </p>
                        <p class="sub-alert" *ngIf="planInformation?.status === 'pending_payment'">
                            <i class="pi pi-exclamation-triangle"></i>
                            {{ 'user.account.subscriptionTab.pendingPaymentAlert' | transloco }}
                        </p>
                    </div>
                    <div class="sub-actions-row">
                        <button class="sub-action-btn" (click)="showUpgradeModal = true">
                            <i class="pi pi-arrow-up"></i> {{ 'user.account.subscriptionTab.changePlanBtn' | transloco }}
                        </button>
                        <button class="sub-action-btn sub-action-btn--primary"
                                *ngIf="planInformation?.billingType === 'stripe'"
                                [disabled]="portalLoading"
                                (click)="openBillingPortal()">
                            <i class="pi pi-external-link"></i>
                            {{ (portalLoading ? 'user.account.subscriptionTab.loading' : 'user.account.subscriptionTab.manageBtn') | transloco }}
                        </button>
                    </div>

                    <!-- Recibos -->
                    <div class="sub-invoices-section sub-invoices-nested">
                        <app-invoice-list-panel (viewDetails)="openInvoiceDetail($event)"></app-invoice-list-panel>
                    </div>
                </div>

                <p class="sub-portal-hint" *ngIf="planInformation?.billingType === 'stripe'">
                    <i class="pi pi-info-circle"></i>
                    {{ 'user.account.subscriptionTab.portalHint' | transloco }}
                </p>
            </div>

            <!-- Meu Tuner (direita) — afiliação a um tuner a qualquer momento, não só no checkout. -->
            <div class="my-tuner-section" id="meu-tuner" *ngIf="showTunerSection">
            <div class="my-tuner-box">
                <span class="sub-eyebrow">{{ 'tuner.myTuner.sectionTitle' | transloco }}</span>

                <div *ngIf="userTunerLoading" class="my-tuner-loading">
                    <p-progressSpinner styleClass="small-spinner" />
                </div>

                <div *ngIf="!userTunerLoading && !userTuner && !showAffiliatePanel" class="my-tuner-empty">
                    <p>{{ 'tuner.myTuner.noTuner' | transloco }}</p>
                    <div class="sub-actions-row my-tuner-actions">
                        <button class="sub-action-btn sub-action-btn--primary" (click)="openAffiliatePanel()">
                            <i class="pi pi-user-plus"></i>
                            {{ 'tuner.myTuner.affiliateBtn' | transloco }}
                        </button>
                    </div>
                </div>

            <!-- Painel de afiliação -->
            <div *ngIf="showAffiliatePanel" class="my-tuner-affiliate-panel">
                <div class="my-tuner-affiliate-header">
                    <span>{{ 'tuner.myTuner.affiliateTitle' | transloco }}</span>
                    <button class="my-tuner-affiliate-close" (click)="cancelAffiliate()">
                        <i class="pi pi-times"></i>
                    </button>
                </div>

                <!-- Toggle lista / código -->
                <div class="my-tuner-mode-toggle">
                    <button [class.active]="affiliateMode === 'list'" (click)="affiliateMode = 'list'; affiliateCodeError = ''; validatedAffiliateTuner = null">
                        <i class="pi pi-list"></i>
                        {{ 'tuner.myTuner.modeList' | transloco }}
                    </button>
                    <button [class.active]="affiliateMode === 'code'" (click)="affiliateMode = 'code'; selectedAffiliateTunerId = null">
                        <i class="pi pi-ticket"></i>
                        {{ 'tuner.myTuner.modeCode' | transloco }}
                    </button>
                </div>

                <!-- Lista de tuners -->
                <div *ngIf="affiliateMode === 'list'">
                    <div *ngIf="affiliateTunersLoading" class="my-tuner-loading">
                        <p-progressSpinner styleClass="small-spinner" />
                    </div>
                    <div *ngIf="!affiliateTunersLoading && affiliateTuners.length === 0" class="my-tuner-empty">
                        {{ 'tuner.myTuner.noTunersAvailable' | transloco }}
                    </div>
                    <div *ngIf="!affiliateTunersLoading" class="my-tuner-tuner-list">
                        <div *ngFor="let t of affiliateTuners"
                             class="my-tuner-tuner-option"
                             [class.enabled]="true"
                             [class.selected]="selectedAffiliateTunerId === t.userID"
                             (click)="selectedAffiliateTunerId = t.userID">
                            <div class="my-tuner-checkbox" [class.checked]="selectedAffiliateTunerId === t.userID">
                                <i *ngIf="selectedAffiliateTunerId === t.userID" class="pi pi-check"></i>
                            </div>
                            <div class="my-tuner-option-icon">
                                <i class="pi pi-star-fill"></i>
                            </div>
                            <div class="my-tuner-option-info">
                                <span class="my-tuner-option-name">{{ t.name }}</span>
                                <span class="my-tuner-option-plans">
                                    <span *ngIf="t.acceptClub" class="my-tuner-plan-tag">Club</span>
                                    <span *ngIf="t.acceptPro" class="my-tuner-plan-tag">Pro</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Código de convite -->
                <div *ngIf="affiliateMode === 'code'" class="my-tuner-code-section">
                    <div class="my-tuner-code-row">
                        <input class="my-tuner-code-input"
                               type="text"
                               [(ngModel)]="affiliateInviteCode"
                               [placeholder]="'tuner.myTuner.codePlaceholder' | transloco" />
                        <button class="my-tuner-validate-btn"
                                [disabled]="!affiliateInviteCode.trim() || affiliateCodeValidating"
                                (click)="validateAffiliateCode()">
                            <i [class]="affiliateCodeValidating ? 'pi pi-spin pi-spinner' : 'pi pi-search'"></i>
                        </button>
                    </div>
                    <div *ngIf="affiliateCodeError" class="my-tuner-code-error">
                        <i class="pi pi-exclamation-circle"></i> {{ affiliateCodeError }}
                    </div>
                    <div *ngIf="validatedAffiliateTuner" class="my-tuner-code-validated">
                        <i class="pi pi-check-circle"></i>
                        <span>{{ validatedAffiliateTuner.name }}</span>
                    </div>
                </div>

                <!-- Ações -->
                <div class="my-tuner-affiliate-actions">
                    <button class="sub-action-btn" (click)="cancelAffiliate()">
                        {{ 'tuner.myTuner.cancelBtn' | transloco }}
                    </button>
                    <button class="sub-action-btn sub-action-btn--primary"
                            [disabled]="affiliateLoading ||
                                        (affiliateMode === 'list' && !selectedAffiliateTunerId) ||
                                        (affiliateMode === 'code' && !validatedAffiliateTuner)"
                            (click)="confirmAffiliate()">
                        <i [class]="affiliateLoading ? 'pi pi-spin pi-spinner' : 'pi pi-user-plus'"></i>
                        {{ affiliateLoading ? ('tuner.myTuner.affiliating' | transloco) : ('tuner.myTuner.confirmBtn' | transloco) }}
                    </button>
                </div>
            </div>

            <div *ngIf="!userTunerLoading && userTuner" class="my-tuner-card"
                 [class.my-tuner-card--inactive]="userTuner.status === 'rejected' || userTuner.status === 'removed'">
                <div class="my-tuner-identity">
                    <span class="my-tuner-monogram" aria-hidden="true">{{ (userTuner.tunerName || '?').charAt(0) | uppercase }}</span>
                    <div class="my-tuner-headline">
                        <span class="my-tuner-name">{{ userTuner.tunerName }}</span>
                        <span class="sub-status-badge" [ngClass]="'sub-status-' + userTuner.status">
                            {{ userTuner.status === 'active'
                                ? ('tuner.myTuner.statusActive' | transloco)
                                : userTuner.status === 'pending'
                                    ? ('tuner.myTuner.statusPending' | transloco)
                                    : userTuner.status === 'rejected'
                                        ? ('tuner.myTuner.statusRejected' | transloco)
                                        : ('tuner.myTuner.statusRemoved' | transloco) }}
                        </span>
                    </div>
                </div>

                <p *ngIf="userTuner.status === 'pending'" class="my-tuner-hint my-tuner-hint--pending">
                    <i class="pi pi-clock"></i>
                    {{ 'tuner.myTuner.pendingHint' | transloco }}
                </p>
                <p *ngIf="userTuner.status === 'rejected'" class="my-tuner-hint my-tuner-hint--rejected">
                    <i class="pi pi-times-circle"></i>
                    {{ 'tuner.myTuner.rejectedHint' | transloco }}
                </p>
                <p *ngIf="userTuner.status === 'removed'" class="my-tuner-hint">
                    <i class="pi pi-info-circle"></i>
                    {{ 'tuner.myTuner.removedHint' | transloco }}
                </p>

                <div class="my-tuner-meta" *ngIf="userTuner.affiliatedAt || userTuner.acceptedAt">
                    <span *ngIf="userTuner.affiliatedAt">
                        <i class="pi pi-calendar"></i>
                        {{ 'tuner.myTuner.since' | transloco }} {{ userTuner.affiliatedAt | date:'dd/MM/yyyy' }}
                    </span>
                    <span *ngIf="userTuner.acceptedAt">
                        <i class="pi pi-check-circle"></i>
                        {{ 'tuner.myTuner.acceptedAt' | transloco }} {{ userTuner.acceptedAt | date:'dd/MM/yyyy' }}
                    </span>
                </div>

                <div class="sub-actions-row my-tuner-actions">
                    <button *ngIf="userTuner.status === 'active' || userTuner.status === 'pending'"
                            class="sub-action-btn"
                            [disabled]="removeTunerLoading"
                            (click)="removeTuner()">
                        <i class="pi" [ngClass]="removeTunerLoading ? 'pi-spin pi-spinner' : 'pi-times'"></i>
                        {{ removeTunerLoading ? ('tuner.myTuner.removing' | transloco) : ('tuner.myTuner.removeBtn' | transloco) }}
                    </button>
                    <button *ngIf="userTuner.status === 'rejected' || userTuner.status === 'removed'"
                            class="sub-action-btn sub-action-btn--primary"
                            (click)="openAffiliatePanel()">
                        <i class="pi pi-user-plus"></i>
                        {{ 'tuner.myTuner.retryBtn' | transloco }}
                    </button>
                </div>
            </div>
            </div>
        </div>

        </div>
    </div>

        <div *ngIf="activeTab === 'trash'" class="trash-panel">
          <p-toast key="trashtAccount" />

          <header class="trash-panel__head">
            <div class="trash-panel__title">
              <span class="trash-panel__icon"><i class="pi pi-trash"></i></span>
              <div class="trash-panel__title-text">
                <h2 class="trash-panel__heading">{{ 'user.trash.header' | transloco }}</h2>
                <span class="trash-panel__count">{{ itensTrash.length }}</span>
              </div>
            </div>
            <span class="trash-panel__search p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                [(ngModel)]="searchValue"
                [ngModelOptions]="{ standalone: true }"
                id="search"
                name="search"
                type="text"
                (input)="onGlobalFilter(dtTrash, $event)"
                (keydown.enter)="onEnterPress($event)"
                placeholder="{{ 'user.trash.search' | transloco }}"
              />
            </span>
          </header>

          <p-table
            class="trash-table"
            #dtTrash
            [value]="itensTrash"
            dataKey="name"
            [totalRecords]="itensTrash.length"
            [sortField]="'deletionDate'"
            [sortOrder]="-1"
            [loading]="loadingTrash"
            responsiveLayout="scroll"
            [rows]="10"
            [paginator]="true"
            [rowsPerPageOptions]="[10, 20, 30]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{{ 'user.account.showing' | transloco }}"
            [rowHover]="true"
            [globalFilterFields]="['name', 'type', 'deletionDate']"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name" style="min-width: 12rem">
                  {{ 'user.trash.name' | transloco }}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="type" style="min-width: 8rem">
                  {{ 'user.trash.type' | transloco }}
                  <p-sortIcon field="type"></p-sortIcon>
                </th>
                <th pSortableColumn="deletionDate" style="min-width: 10rem">
                  {{ 'user.trash.deletionDate' | transloco }}
                  <p-sortIcon field="deletionDate"></p-sortIcon>
                </th>
                <th class="trash-table__actions-col" style="width: 7rem">
                  {{ 'user.trash.action' | transloco }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item">
                <td class="trash-table__name">
                  <i class="trash-table__type-icon" [ngClass]="trashTypeIcon(item.type)"></i>
                  <span class="trash-table__name-text"
                        [class.trash-table__name-text--derived]="!trashHasName(item)"
                        [pTooltip]="trashHasName(item) ? '' : ('user.trash.noNameHint' | transloco)"
                        tooltipPosition="top">{{ trashLabel(item) }}</span>
                </td>
                <td>
                  <span class="trash-badge" [ngClass]="'trash-badge--' + (item.type | lowercase)">
                    {{ item.type }}
                  </span>
                </td>
                <td class="trash-table__date">
                  {{ item.deletionDate | dynamicDateHour: currentLocale }}
                </td>
                <td>
                  <div class="trash-table__actions">
                    <button
                      type="button"
                      class="trash-action trash-action--restore ftds-chamfer-bordered"
                      pTooltip="{{ 'user.trash.restoreItem' | transloco }}"
                      tooltipPosition="top"
                      (click)="restore(item)"
                    >
                      <i class="pi pi-undo"></i>
                    </button>
                    <button
                      *ngIf="showTrash(item.type)"
                      type="button"
                      class="trash-action trash-action--delete"
                      pTooltip="{{ 'user.trash.permanently.header' | transloco }}"
                      tooltipPosition="top"
                      (click)="trashPermanently(item)"
                    >
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">
                  <div class="trash-empty">
                    <i class="pi pi-inbox"></i>
                    <span>{{ 'user.trash.noResult' | transloco }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

    <!-- ── ABA CONSUMO IA ── -->
    <div *ngIf="activeTab === 'ai'" class="ai-tab-container">

        <!-- Loading -->
        <div *ngIf="aiUsageLoading" class="ai-loading">
            <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
        </div>

        <!-- Error: sem créditos, assinatura expirada (mensagem específica + CTA de renovar) -->
        <div *ngIf="!aiUsageLoading && aiUsageError && planInformation?.status === 'expired'" class="ai-no-credits">
            <i class="pi pi-clock"></i>
            <p>{{ 'user.account.aiExpiredPlan' | transloco: { name: planInformation?.name } }}</p>
            <button class="sub-upgrade-btn" (click)="showUpgradeModal = true">
                <i class="pi pi-refresh"></i> {{ 'user.account.subscriptionTab.renewBtn' | transloco }}
            </button>
        </div>

        <!-- Error: falha real de carga. O Free não cai mais aqui — desde a reserva gratuita
             o endpoint responde 200 com credits zerados e o conteúdo em free_tank. -->
        <div *ngIf="!aiUsageLoading && aiUsageError && planInformation?.status !== 'expired'" class="ai-no-credits">
            <i class="pi pi-exclamation-triangle"></i>
            <p>{{ 'user.account.aiLoadFailed' | transloco }}</p>
        </div>

        <!-- AI Usage content -->
        <div *ngIf="!aiUsageLoading && !aiUsageError && aiUsage">

            <!-- Summary card -->
            <h3 class="ai-section-title">{{ 'user.account.aiSectionConsumption' | transloco }}</h3>
            <div class="ai-usage-card">

                <!-- Medidor de tanques (tank_size_tokens presente) -->
                <ng-container *ngIf="hasTankGauge(); else usageBarFallback">
                    <div class="ai-tank-panel">

                      <!-- Poço de instrumentos: mostrador e galão sobre o mesmo fundo profundo. -->
                      <div class="ai-well">

                        <!-- Mostrador do tanque em uso -->
                        <div class="ai-gauge">
                            <!-- Mostrador analógico: escala impressa e ponteiro, sem barra de
                                 progresso. As zonas âmbar e vermelha são serigrafadas na própria
                                 escala e ficam visíveis em qualquer nível — é onde o perigo está,
                                 não quanto já foi gasto. Os pontos vêm do círculo r=74 centrado
                                 em (100,104): 6% e 15% da varredura de 180°. -->
                            <svg class="ai-gauge-dial" viewBox="0 0 200 132" aria-hidden="true">
                                <path class="ai-gauge-track" d="M 26 104 A 74 74 0 0 1 174 104"></path>
                                <path class="ai-gauge-zone reserve" d="M 27.31 90.13 A 74 74 0 0 1 34.07 70.4"></path>
                                <path class="ai-gauge-zone dry" d="M 26 104 A 74 74 0 0 1 27.31 90.13"></path>
                                <line *ngFor="let tick of gaugeTicks" class="ai-gauge-tick" [class.major]="tick.major"
                                      x1="100" y1="30" x2="100" [attr.y2]="tick.y2" [attr.transform]="tick.transform"></line>
                                <text class="ai-gauge-endmark" x="21" y="122">E</text>
                                <text class="ai-gauge-endmark" x="100" y="24">&#189;</text>
                                <text class="ai-gauge-endmark" x="179" y="122">F</text>
                                <polygon class="ai-gauge-needle" points="100,44 96.8,101 100,116 103.2,101"
                                         [style.transform]="getNeedleRotation()"></polygon>
                                <circle class="ai-gauge-hub" cx="100" cy="104" r="7.5"></circle>
                                <circle class="ai-gauge-hub-core" cx="100" cy="104" r="3"></circle>
                            </svg>

                            <!-- Luz de reserva: apagada de verdade quando há combustível. -->
                            <span class="ai-gauge-lamp" [class.is-on]="isOnReserve">
                                <!-- Bomba de combustível: PrimeIcons não tem esse ícone, então vai
                                     como path inline — é o mesmo do mockup. -->
                                <svg class="ai-gauge-lamp-icon" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M6 2h7a2 2 0 0 1 2 2v6h1.5A2.5 2.5 0 0 1 19 12.5V18a1 1 0 0 0 2 0v-6h1.2l-2.2-3.4.9-.6L23.6 12H21v6a2 2 0 0 1-4 0v-5.5a.5.5 0 0 0-.5-.5H15v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2Zm0 2v5h7V4H6Z" />
                                </svg>
                                {{ 'user.account.tankReserveLamp' | transloco }}
                            </span>

                            <!-- Percentual do tanque em uso. Na reserva a leitura que importa é a do galão. -->
                            <div class="ai-readout" *ngIf="!isReserveActive">
                                <span class="ai-readout-label">{{ 'user.account.tankAvailableLabel' | transloco }}</span>
                                <span class="ai-readout-value">
                                    <svg class="ai-readout-icon" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M6 2h7a2 2 0 0 1 2 2v6h1.5A2.5 2.5 0 0 1 19 12.5V18a1 1 0 0 0 2 0v-6h1.2l-2.2-3.4.9-.6L23.6 12H21v6a2 2 0 0 1-4 0v-5.5a.5.5 0 0 0-.5-.5H15v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2Zm0 2v5h7V4H6Z" />
                                    </svg>
                                    {{ getCurrentTankPercent() }}%
                                </span>
                            </div>
                        </div>

                        <!-- Tanque em uso + reserva -->
                        <div class="ai-tank-bank">
                            <div class="ai-tank-row">
                                <!-- Galão: corpo, bico e alça vivem em <defs> e são referenciados
                                     por <use>, então a pilha de trás usa a MESMA silhueta da frente.
                                     O líquido é um rect recortado pelo corpo — sobe de y=104 (fundo)
                                     até y=34 (topo), 70 de altura útil. -->
                                <svg class="ai-tank-art" viewBox="0 0 118 116" aria-hidden="true">
                                    <defs>
                                        <path id="canBody" d="M20 34 h44 a6 6 0 0 1 6 6 v58 a6 6 0 0 1 -6 6 h-44 a6 6 0 0 1 -6 -6 v-58 a6 6 0 0 1 6 -6 z" />
                                        <path id="canSpout" d="M22 34 v-7 a3 3 0 0 1 3 -3 h6 a3 3 0 0 1 3 3 v7" />
                                        <path id="canHandle" d="M40 24 h18 a4 4 0 0 1 4 4 v6" />
                                        <clipPath id="canClip"><use href="#canBody" /></clipPath>
                                    </defs>

                                    <ng-container *ngIf="reserveTanks > 0">
                                        <use class="can-stack" href="#canBody" x="34" y="4" opacity=".55" />
                                        <use class="can-stack" href="#canBody" x="22" y="2" opacity=".8" />
                                    </ng-container>

                                    <use class="can-glass" href="#canBody" />

                                    <g clip-path="url(#canClip)" *ngIf="getCurrentTankPercent() > 0">
                                        <g class="can-fill">
                                            <rect class="can-liquid" x="14" [attr.y]="canLiquidY" width="56"
                                                  [attr.height]="canLiquidHeight" [attr.fill]="tankLevelColor" />
                                            <rect class="can-shine" x="22" [attr.y]="canLiquidY + 3" width="9"
                                                  [attr.height]="canShineHeight" rx="4" />

                                            <!-- Onda e bolhas: os dois galões recebem o
                                                 mesmo bloco, só mudando a cor e a geometria
                                                 do líquido. Mantê-los idênticos é o ponto —
                                                 foi a divergência entre eles que fez o efeito
                                                 sumir da reserva. -->
                                            <g class="can-waves" [attr.transform]="'translate(0 ' + canLiquidY + ')'">
                                                <path class="can-wave" [attr.d]="canWavePath" [attr.fill]="tankLevelColor" />
                                                <path class="can-wave can-wave-alt" [attr.d]="canWavePath" [attr.fill]="tankLevelColor" />
                                            </g>
                                            <g class="can-bubbles" [style.--rise]="canLiquidHeight + 'px'">
                                                <circle *ngFor="let b of canBubbles" class="can-bubble"
                                                        [attr.cx]="b.cx" cy="104" [attr.r]="b.r"
                                                        [style.animation-duration]="b.duration"
                                                        [style.animation-delay]="b.delay"
                                                        [style.--drift]="b.drift" />
                                            </g>
                                        </g>
                                    </g>

                                    <use class="can-outline" href="#canBody" [style.stroke]="tankOutlineColor" />
                                    <use class="can-outline" href="#canSpout" fill="none" [style.stroke]="tankOutlineColor" />
                                    <use class="can-outline" href="#canHandle" fill="none" [style.stroke]="tankOutlineColor" />

                                    <g transform="translate(78 78)" *ngIf="reserveTanks > 0">
                                        <rect class="can-badge-bg" x="0" y="0" width="30" height="19" rx="4" />
                                        <text class="can-badge-text" x="15" y="14" text-anchor="middle">+{{ reserveTanks }}</text>
                                    </g>

                                    <!-- Reserva gratuita: mesma silhueta em escala menor, ao lado do
                                         galão principal — que aqui está necessariamente vazio, porque a
                                         reserva só é gasta com o crédito pago em zero. O tamanho menor
                                         diz que a cota é menor; o laranja diz que é outro tipo de
                                         crédito, não que está acabando. Ocupa a área do badge "+N", que
                                         nunca aparece junto (sem crédito pago não há tanque atrás). -->
                                    <g *ngIf="isReserveActive" class="can-reserve"
                                       [attr.transform]="'translate(76 46) scale(' + reserveCanScale + ')'">
                                        <use class="can-glass" href="#canBody" />
                                        <g clip-path="url(#canClip)" *ngIf="reserveFillPercent > 0">
                                            <g class="can-fill">
                                                <rect class="can-liquid" x="14" [attr.y]="reserveLiquidY" width="56"
                                                      [attr.height]="reserveLiquidHeight" fill="var(--ftds-warn)" />
                                                <rect class="can-shine" x="22" [attr.y]="reserveLiquidY + 3" width="9"
                                                      [attr.height]="reserveShineHeight" rx="4" />

                                                <!-- Onda e bolhas: os dois galões recebem o
                                                     mesmo bloco, só mudando a cor e a geometria
                                                     do líquido. Mantê-los idênticos é o ponto —
                                                     foi a divergência entre eles que fez o efeito
                                                     sumir da reserva. -->
                                                <g class="can-waves" [attr.transform]="'translate(0 ' + reserveLiquidY + ')'">
                                                    <path class="can-wave" [attr.d]="canWavePath" [attr.fill]="'var(--ftds-warn)'" />
                                                    <path class="can-wave can-wave-alt" [attr.d]="canWavePath" [attr.fill]="'var(--ftds-warn)'" />
                                                </g>
                                                <g class="can-bubbles" [style.--rise]="reserveLiquidHeight + 'px'">
                                                    <circle *ngFor="let b of canBubbles" class="can-bubble"
                                                            [attr.cx]="b.cx" cy="104" [attr.r]="b.r"
                                                            [style.animation-duration]="b.duration"
                                                            [style.animation-delay]="b.delay"
                                                            [style.--drift]="b.drift" />
                                                </g>
                                            </g>
                                        </g>
                                        <use class="can-outline" href="#canBody" />
                                        <use class="can-outline" href="#canSpout" fill="none" />
                                        <use class="can-outline" href="#canHandle" fill="none" />
                                    </g>
                                </svg>
                            </div>
                            <div class="ai-readout" *ngIf="!isReserveActive">
                                <span class="ai-readout-label">
                                    {{ (tanksWithFuel === 1 ? 'user.account.tankLeftLabel' : 'user.account.tanksLeftLabel') | transloco }}
                                </span>
                                <span class="ai-readout-value">{{ tanksWithFuel }}</span>
                            </div>

                            <!-- Na reserva a contagem de tanques diria sempre "0 tanques": o número
                                 que importa é quanto resta da cota e quando ela volta. -->
                            <div class="ai-readout ai-readout-reserve" *ngIf="isReserveActive">
                                <span class="ai-readout-label">{{ 'user.account.reserveLabel' | transloco }}</span>
                                <span class="ai-readout-value">{{ reserveFillPercent }}%</span>
                                <span class="ai-reserve-refill" *ngIf="reserveState === 'prospective'">
                                    {{ 'user.account.reserveWindowNotStarted' | transloco: { hours: freeTank?.window_hours } }}
                                </span>
                                <span class="ai-reserve-refill" *ngIf="reserveState !== 'prospective'">
                                    <i class="pi pi-refresh"></i>
                                    {{ 'user.account.reserveRefillAt' | transloco: { time: (freeTank?.refill_at | date: 'HH:mm'), countdown: reserveCountdownLabel } }}
                                </span>
                            </div>
                        </div>
                      </div>

                        <!-- Como o sistema de tanques funciona. Ficha, não lista de bullets:
                             as três regras são de naturezas diferentes (fluxo, perda,
                             durabilidade) e o termo à esquerda diz de qual se trata, então o
                             texto à direita não precisa repetir o sujeito. -->
                        <div class="ai-tank-help">
                            <span class="ai-tank-help-title">{{ 'user.account.tankHelpTitle' | transloco }}</span>
                            <dl class="ai-tank-rules">
                                <div class="ai-tank-rule">
                                    <dt>{{ 'user.account.tankRuleUsageTerm' | transloco }}</dt>
                                    <dd [innerHTML]="'user.account.tankRuleUsageText' | transloco"></dd>
                                </div>
                                <div class="ai-tank-rule">
                                    <dt>{{ 'user.account.tankRulePlanTerm' | transloco }}</dt>
                                    <dd [innerHTML]="'user.account.tankRulePlanText' | transloco"></dd>
                                </div>
                                <div class="ai-tank-rule">
                                    <dt>{{ 'user.account.tankRuleExtraTerm' | transloco }}</dt>
                                    <dd [innerHTML]="'user.account.tankRuleExtraText' | transloco"></dd>
                                </div>
                                <div class="ai-tank-rule" *ngIf="showReserveRule">
                                    <dt>{{ 'user.account.tankRuleReserveTerm' | transloco }}</dt>
                                    <dd [innerHTML]="'user.account.tankRuleReserveText' | transloco: { hours: freeTank?.window_hours }"></dd>
                                </div>
                            </dl>
                        </div>

                        <!-- Tanques extra. Com lote vencendo dentro da janela de aviso, o bloco
                             mostra o lote e o prazo — é o único dado da conta que a API expõe
                             sobre compras, e substitui aqui o banner de expiração. Fora da
                             janela não dá pra afirmar que o usuário não tem tanque extra (o
                             contrato não devolve o saldo comprado), então fica só o que a
                             compra resolve. -->
                        <!-- Reserva já em uso num plano que não compra tanque avulso: a saída
                             é assinar, não comprar. -->
                        <div class="ai-tank-cta" *ngIf="showReserveUpgradeCta">
                            <span class="ai-tank-help-title">{{ 'user.account.reserveCtaTitle' | transloco }}</span>
                            <p class="ai-tank-cta-text">{{ 'user.account.reserveCtaText' | transloco }}</p>
                            <button class="sub-upgrade-btn ai-tank-cta-btn" (click)="showUpgradeModal = true">
                                <i class="pi pi-arrow-up"></i> {{ 'user.account.reserveCtaBtn' | transloco }}
                            </button>
                        </div>

                        <!-- Sem poder comprar (Free, ou plano fora de vigência): o convite é
                             assinar. A mesma modal de planos dos demais CTAs da tela. -->
                        <div class="ai-tank-cta" *ngIf="showPlanUpgradeCta">
                            <span class="ai-tank-help-title">{{ 'user.account.tankUpgradeTitle' | transloco }}</span>
                            <p class="ai-tank-cta-text">{{ 'user.account.tankUpgradeText' | transloco }}</p>
                            <button class="sub-upgrade-btn ai-tank-cta-btn" (click)="showUpgradeModal = true">
                                <i class="pi pi-arrow-up"></i> {{ 'user.account.tankUpgradeBtn' | transloco }}
                            </button>
                        </div>

                        <div class="ai-tank-cta" *ngIf="canBuyTokens">
                            <span class="ai-tank-help-title">{{ 'user.account.tankCtaTitle' | transloco }}</span>

                            <div class="ai-extra-expiry" *ngIf="shouldShowExpiringWarning(); else extraPitch">
                                <div class="ai-extra-amount">
                                    <span class="ai-extra-value">{{ expiringTanks | number:'1.0-1' }}</span>
                                    <span class="ai-extra-unit">{{ 'user.account.tankExtraExpiringUnit' | transloco }}</span>
                                </div>
                                <!-- A barra mede a janela de aviso, não os 12 meses de validade:
                                     a data da compra não vem no contrato. -->
                                <div class="ai-extra-track">
                                    <div class="ai-extra-fill" [style.width.%]="expiringWindowPercent"></div>
                                </div>
                                <div class="ai-extra-deadline">
                                    <b>{{ expiringInKey | transloco: { days: getExpiringDays() } }}</b>
                                    <span>{{ getExpiringDateFormatted() }}</span>
                                </div>
                            </div>
                            <ng-template #extraPitch>
                                <p class="ai-tank-cta-text">{{ 'user.account.tankCtaText' | transloco }}</p>
                            </ng-template>

                            <button class="sub-upgrade-btn ai-tank-cta-btn" (click)="showBuyTokensModal = true">
                                <i class="pi pi-shopping-cart"></i> {{ 'user.account.tankCtaBtn' | transloco }}
                            </button>
                        </div>
                    </div>

                </ng-container>

                <!-- Fallback: sem tank_size_tokens, mantém o display percentual antigo -->
                <ng-template #usageBarFallback>
                    <div class="ai-usage-bar">
                        <div class="ai-usage-bar-fill"
                             [ngClass]="getUsageBarClass()"
                             [ngStyle]="{ 'width': getUsagePercent() + '%' }">
                        </div>
                    </div>

                    <div class="ai-usage-stats">
                        <span class="ai-usage-credits">
                            {{ 'user.account.aiCreditsUsed' | transloco: { used: (aiUsage.credits_used_this_period | number:'1.0-0'), limit: (aiUsage.credits_total | number:'1.0-0') } }}
                        </span>
                        <span class="ai-usage-percent">{{ getUsagePercent() | number:'1.0-0' }}%</span>
                    </div>

                </ng-template>


                <!-- Só com cota mensal: os dois itens falam do ciclo de renovação da cota,
                     que o Free não tem. Ver hasMonthlyQuota pra por que a condição é
                     credits_limit e não free_tank.active. -->
                <div class="ai-usage-meta" *ngIf="hasMonthlyQuota">
                    <div class="ai-usage-meta-item">
                        <i class="pi pi-calendar"></i>
                        {{ 'user.account.aiPeriod' | transloco }}:
                        <b>{{ aiUsage.period_start | date:'dd/MM/yyyy' }} – {{ aiUsage.period_end | date:'dd/MM/yyyy' }}</b>
                    </div>
                    <div class="ai-usage-meta-item">
                        <i class="pi pi-refresh"></i>
                        {{ 'user.account.aiRenewalDay' | transloco: { day: aiUsage.billing_anchor_day } }}
                    </div>
                </div>

                <!-- No modo tanque o prazo vive no bloco "Tanques extra"; aqui o banner
                     cobre só o fallback, pra esse modo não perder o aviso. -->
                <div class="ai-expiring-warning" *ngIf="!hasTankGauge() && shouldShowExpiringWarning()">
                    <i class="pi pi-exclamation-triangle"></i>
                    {{ 'user.account.aiExpiringWarning' | transloco: { amount: aiUsage.next_expiring_amount, days: getExpiringDays(), date: getExpiringDateFormatted() } }}
                </div>
            </div>

            <!-- No modo tanque este botão vive dentro do painel (bloco "Tanques extra");
                 aqui ele cobre só o fallback, pra não deixar esse modo sem como comprar. -->
            <div class="ai-buy-row" *ngIf="!hasTankGauge() && canBuyTokens">
                <button class="sub-action-btn" (click)="showBuyTokensModal = true">
                    <i class="pi pi-shopping-cart"></i> {{ 'user.account.aiBuyMoreBtn' | transloco }}
                </button>
            </div>

            <!-- History table -->
            <div class="ai-history-section">
                <h3 class="ai-section-title">{{ 'user.account.aiHistoryTitle' | transloco }}</h3>

                <div class="ai-history-card">
                <div *ngIf="aiHistoryLoading && aiHistory.length === 0" class="ai-loading">
                    <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
                </div>

                <div *ngIf="!aiHistoryLoading && aiHistory.length === 0" class="ai-empty">
                    <i class="pi pi-inbox"></i>
                    <p>{{ 'user.account.aiNoHistory' | transloco }}</p>
                </div>

                <p-table *ngIf="aiHistory.length > 0"
                         [value]="aiHistory"
                         [lazy]="true"
                         [paginator]="true"
                         [rows]="aiHistoryPageSize"
                         [totalRecords]="aiHistoryTotalCount"
                         [loading]="aiHistoryLoading"
                         (onLazyLoad)="onAiHistoryPageChange($event)"
                         styleClass="p-datatable-sm ai-history-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 56%">{{ 'user.account.aiType' | transloco }}</th>
                            <th style="width: 24%">{{ 'user.account.aiDate' | transloco }}</th>
                            <th style="width: 20%; text-align: right;">{{ (hasHistoryTankSize() ? 'user.account.aiTank' : 'user.account.aiCredits') | transloco }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <div class="ai-history-type">
                                    <i class="pi" [ngClass]="getAiTypeIcon(item.type)"></i>
                                    <span>{{ getAiTypeLabel(item.type) }}</span>
                                    <i class="pi pi-info-circle ai-type-info"
                                       *ngIf="getAiTypeDescription(item.type)"
                                       [pTooltip]="getAiTypeDescription(item.type)"
                                       tooltipPosition="top"></i>
                                    <!-- Origem do crédito. "Plano" é o caso comum e fica sem tag:
                                         marcá-lo transformaria a coluna inteira em etiquetas. -->
                                    <span class="ai-origin-tag ai-origin-reserve"
                                          *ngIf="aiHistoryOrigin(item) === 'reserve'">
                                        {{ 'user.account.aiOriginReserve' | transloco }}
                                    </span>
                                    <span class="ai-origin-tag ai-origin-purchase"
                                          *ngIf="aiHistoryOrigin(item) === 'purchase'">
                                        {{ 'user.account.aiOriginPurchase' | transloco }}
                                    </span>
                                </div>
                                <div class="ai-history-preview" *ngIf="item.query_preview">{{ aiHistoryPreview(item) }}</div>
                            </td>
                            <td class="ai-history-date">{{ item.created_date | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td class="ai-history-credits">
                                <span class="ai-credits-badge" [class.ai-credits-badge--positive]="item.amount >= 0">{{ formatAiHistoryAmount(item.amount) }}</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                </div>
            </div>
        </div>
    </div>
    
    <p-confirmDialog></p-confirmDialog>

    <app-pro-feature-modal
        [(visible)]="showUpgradeModal"
        [currentPlanId]="planInformation?.planId ?? null"
        [currentPlanExpired]="planInformation?.status === 'expired'"
        [billingType]="planInformation?.billingType ?? null"
        (planUpgraded)="onPlanUpgraded()" />

    <app-token-purchase-modal
        [(visible)]="showBuyTokensModal"
        [currentCreditsTotal]="aiUsage?.credits_total ?? null" />

    <app-invoice-detail-modal
        [(visible)]="showInvoiceDetailModal"
        [invoiceId]="selectedInvoiceId"
        (notFound)="onInvoiceNotFound()" />
